<script>
import Section from '../../components/PageSection'
import Ajouter from '../../components/PageForm'
import Modale from '../../components/Modale'
import Toggle from '../../components/DivToggleText'
import ValFlagger from '../../components/params/ValFlagger'
import Spinner from '../../components/Spinner';

import { updateMontant } from '../../mixins/updateMontant.js';
import { allAboutDates } from '../../mixins/allAboutDates'

export default {
  name: 'Temps',
  components: {
    Section,
    Ajouter,
    Modale,
    Toggle,
    ValFlagger,
    Spinner,
  },
  mixins:[
    updateMontant,
    allAboutDates,
  ],
  data(){
    return{
      modeSaisie: null,
      agence: null,
      coeffs: [],
      displayedYear: (new Date).getUTCFullYear(),
      modale: {ref: String, val: Boolean},
      fullyLoaded: false,
      }
  },
  async mounted(){
    //Chargement de l'agence
    const promiseAgence = this.$axios.get('agences/paramsTemps/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear)
    .then(response => {
      this.agence = response.data

      //Mode saisie : si aucun, valeur par défaut
      switch (this.agence.modeSaisie) {
        case 1:
          this.modeSaisie = false;
          break;
        // case 2:
        case 3:
          this.modeSaisie = true;
          break;
        default:
          console.log("Mode de saisie inconnu. Passage à 'heures pas jour' par défaut.");
          this.$axios.put('agences/' + this.$store.state.auth.currentAgence._id, {modeSaisie: 1})
          .then(response =>{
            console.log(response.data);
            this.modeSaisie = false;
          });
      }
    });

    let coeffLabels = []

    //Chargement des coeffsLabels
    const promiseCoeff = this.$axios.get('coeffLabels/getAll/' + this.$store.state.auth.currentAgence._id)
    .then(response => coeffLabels = response.data)
    .catch(err => console.log(err))

    await Promise.all([promiseAgence, promiseCoeff])

    //Ajout de la valeur des coeffs pour l'année en cours
    const promiseValeurs = this.$axios.get('coeffs/getByYear/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear)
    .then(res => {
      this.coeffs = coeffLabels

      for (const item of this.coeffs) {
        //Déclaration d'une nouvelle propriété réactive
        if (res.data.find(e => e.labelId == item._id)){
          this.$set(item, 'val', res.data.find(e => e.labelId == item._id).val)
        } else {
          this.$set(item, 'val', 0)
        }
      }

      this.fullyLoaded = true
    })
    .catch(err => console.log(err))

    await Promise.all([promiseValeurs])
    

  },
  computed:{
    totalCharges(){
      return this.updateMontant(this.agence.estimationsAnnuelles.salairesBruts.val + this.agence.estimationsAnnuelles.chargesDirectes.val + this.agence.estimationsAnnuelles.chargesIndirectes.val).str
    },
    cr(){
      let a = this.agence.estimationsAnnuelles.chargesIndirectes.val + this.agence.estimationsAnnuelles.salairesBruts.val * (1 - (this.agence.estimationsAnnuelles.salaireFacturable.val /100))
      let b = this.agence.estimationsAnnuelles.salairesBruts.val * (this.agence.estimationsAnnuelles.salaireFacturable.val /100)
      return Math.round((a / b + 1) * 100) /100
    },
    salaireJourMoy(){
      let a = this.agence.estimationsAnnuelles.salairesBruts.val
      let b = this.agence.estimationsAnnuelles.nbJours.val * 12 * this.agence.estimationsAnnuelles.nbCollaborateurs.val
      return Math.round(a / b)
    },
    crJour(){
      return Math.round(this.salaireJourMoy * this.cr)
    },
    pv(){
      let a = this.agence.estimationsAnnuelles.marge.val
      let b = this.agence.estimationsAnnuelles.salairesBruts.val * (this.agence.estimationsAnnuelles.salaireFacturable.val /100)
      return Math.round((this.cr + (a/b)) * 100) /100
    },
    pvJour(){
      return Math.round(this.salaireJourMoy * this.pv)
    },
    coeffsPerso(){
      if (this.coeffs.length){
        return this.coeffs.filter(e => (e.sphem == undefined && !e.deleted))
      } else {
        return []
      }
      
    },
  },
  methods:{
    //-------------------------------
    //            Modales
    //-------------------------------
    closeModales(){
      this.modale.val = false;
    },
    showModale(ref){
      this.modale.ref = ref
      this.modale.val = true;
    },

    //-------------------------------
    //        Mode de saisie
    //-------------------------------
    modeChanged(){
      this.modeSaisie = !this.modeSaisie;
      
      if (this.modeSaisie){
        this.$axios.put('agences/' + this.$store.state.auth.currentAgence._id, {modeSaisie: 3})
        .then(response =>{
          console.log(response.data);
        });
        this.agence.modeSaisie = 3;
      } else {
        this.$axios.put('agences/' + this.$store.state.auth.currentAgence._id, {modeSaisie: 1})
        .then(response =>{
          console.log(response.data);
        });
        this.agence.modeSaisie = 1;
      }

      this.$store.dispatch('auth/majMode', this.agence);
    },

    //-------------------------------
    //        Jours fériés
    //-------------------------------
    jfChanged(){
      this.$axios.put('agences/' + this.$store.state.auth.currentAgence._id, {alsace: this.agence.alsace})
      .then(response => {
        console.log(response.data);
      })
      .catch(e => {
        console.log("erreur : " + e);
      });
    },

    //-------------------------------
    //        Coefficients
    //-------------------------------
    addCoeff(payload){
      let item = {
        agenceId  : this.$store.state.auth.currentAgence._id,
        name      : payload[0],
        active    : true,
        deleted   : false,
        rank      :this.coeffs.length + 1,
      }

      this.$axios.post('coeffLabels/register', item)
      .then(response => {
        console.log(response.data.message)
        //J'ajoute l'Id reçu de serveur à mon objet item en local pour l'ajouter à mon client et pouvoir le manipuler
        item._id = response.data.coeffId;
        this.coeffs.push(item);
      })
      .catch(e => {
        console.log(e);
      });
    },
    checkIsChanged(id, active){
      this.$axios.put('coeffLabels/' + id, {
        active : active,
      })
    },
    deleteCoeff(id){
      this.$axios.put('coeffLabels/' + id, {
        deleted : true,
      })
      .then(response => {
        console.log(response)
        this.coeffs.find(e => e._id == id).deleted = true;
      })
    },
    changeYear(sens){
      if (sens > 0){
        this.displayedYear += 1;
      } else {
        this.displayedYear -= 1;
      }

      //Mise à jour des estimations de la nouvelle année en cour
      this.$axios.get('agences/paramsTemps/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear)
      .then(response => {
        this.agence = response.data
      })

      //Mise à jour de la valeur des coeff de la nouvelle année en cours
      this.$axios.get('coeffs/getByYear/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear)
      .then(response => {
        //Il n'y a pas forcément de valeur pour chaque coeff pour cette nouvelle année, mon élément "response" est peut-être vide ou incomplet. Inscrire les nouvelles valeurs via ma boucle "for" risque de laisser les anciennes valeurs s'il n'y en a pas de nouvelle pour remplacer : j'efface tout avant la boucle.
        for (let item of this.coeffs){
          item.val = undefined
        }

        for (let item of response.data){
          //Déclaration d'une nouvelle propriété réactive
          this.$set(this.coeffs.find(e => e._id == item.labelId), 'val', item.val)
        }
      })
      .catch(err => console.log(err))
      
    },

    majEstimations(target, annee){
      //Si c'est bien un nombre positif ou nul
      if (this.updateMontant(target.value) && this.updateMontant(target.value).num >=0){
        target.classList.remove("coeff__calcul__value__error")

        //Calcul par défaut du nombre de jour par mois si l'user a supprimé toute valeur à cet endroit
        //NB: si la valeur en base est >= 0, alors je vais ajouter une nouvelle valeur lors de la routine annuelle au login. Je me retrouverai avec de valeur pour la même année. A éviter....
        if (target.id == 'nbJours' && (!target.value || this.updateMontant(target.value).num == 0)){
          target.value = Math.round(this.joursOuvres(annee, this.agence.alsace)/12*100)/100
        }

        this.$axios.put('agences/paramsTemps/' + this.$store.state.auth.currentAgence._id, {
          target  : target.id,
          annee   : annee,
          val     : this.updateMontant(target.value).num
        })
        .then(response => {
          console.log(response.data)
          this.agence.estimationsAnnuelles[target.id].val = this.updateMontant(target.value).num

          // Mise à jour des coefficients CR & PV s'ils sont "truthy"
          if (this.cr){this.$axios.put('coeffs/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear + '/' + this.coeffs.find(e => e.sphem == "cr")._id, {val: this.cr})}
          if (this.pv){this.$axios.put('coeffs/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear + '/' + this.coeffs.find(e => e.sphem == "pv")._id, {val: this.pv})}
          
        })
        .catch(e => console.log(e.message));
      } else {
        target.classList.add("coeff__calcul__value__error")
      }
    },
    majCoeff(labelId, target){
      if (isNaN(target.value)){
        target.classList.add("coeff__calcul__value__error")
      } else if (target.value == 0){
        this.$axios.delete('coeffs/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear + '/' + labelId)
        this.coeffs.find(e => e._id == labelId).val = 0
      } else {
        target.classList.remove("coeff__calcul__value__error")
        this.$axios.put('coeffs/' + this.$store.state.auth.currentAgence._id + '/' + this.displayedYear + '/' + labelId, {
          val : target.value
        })
        .then(response => {
          console.log(response.data)
          this.coeffs.find(e => e._id == labelId).val = target.value
        })
        .catch(err => console.log(err))
      }
    }
  },
}
</script>


<template>
  <div v-if="!fullyLoaded">
    <Spinner/>
  </div>
  <div v-else>
    <div style="width: 700px;" v-if="agence">
      <Section text="Mode de saisie" v-if="modeSaisie != null">
        <template v-slot:body>
          <div class="content">
            <div class="content__text">Vous pouvez choisir de saisir vos temps passés soit en indiquant un nombre d'heures pour chaque jour, soit en indiquant un nombre de jour pour chaque mois. D'autres modes pourront être ajoutés par la suite si nécessaires.</div>
            <div class="content__list">
              <Toggle option1="Heures par jour" option2="Jours par mois" :givenStatut="modeSaisie" @toggled="modeChanged" class="content__item__toggle"/>
              <transition name="fade">
                <ValFlagger v-if="agence.modeSaisie == 1" class="content__list__valFlagger" unit="heures/jour" array="equivHJ" :api="'agences/' + $store.state.auth.currentAgence._id" />
              </transition>
            </div>
          </div>
        </template>
      </Section>

      <Section text="Jours fériés">
        <template v-slot:body>
          <div class="content">
            <div class="content__text">Si vous déclarez faire partie du régime Alsace / Moselle, le vendredi Saint et la Saint Etienne (26/12) seront ajoutés aux jours fériés.</div>
            <div class="content__list">
              <div class="content__list__item">
                <label class="content__list__item__label">Régime Alsace / Moselle</label>
                <input type="checkbox" class="inline-block" @change="jfChanged" v-model="agence.alsace">
              </div>
            </div>
          </div>
        </template>
      </Section>

      <Section text="Conversion des temps en euros">
        <template v-slot:body>
          <div class="content">
            <div class="content__text">
            La rentabilité d'un projet, c'est la différence entre ce qu'il coûte et ce qu'il rapporte. Pour calculer ce que coûte un projet, il est nécessaire de prendre en compte une part des frais généraux de l'agence (administratif, loyer, assurances, etc.). Pour cela, on utilise des coefficients.
            <p>Par défaut, si rien n'est spécifié pour une année, le coefficient coût de revient est fixé à 2, et le prix de vente à 2.2.</p>
            <!-- <p>Voici un détail des calculs :</p>
            <p>Le total des charges de l'agence sur l'année est de : {{
              updateMontant(updateMontant(agence.estimationsAnnuelles.salairesBruts.val).num +
              updateMontant(agence.estimationsAnnuelles.chargesDirectes.val).num +
              updateMontant(agence.estimationsAnnuelles.chargesIndirectes.val).num).str}}€.
              Les charges directes (777€) et les salaires facturables (777€) sont directement couverts par les projets. Les charges indirectes et les salaires non facturables représentent 888€.
              Ce montant est réparti au prorata du salaire : 888€ / 999€ = 0.6. Donc pour 1€ de salaire dépensé sur un projet facturable, il faudra également couvrir 0.6€ de charges et salaire non fcaturable.
              Ce qui revient à multiplier chaque € de salaire par 1,66 (Coût de revient)
            </p> -->
            </div>
            <div class="content__list">
              <div class="coeff__liste">
                <div class="coeff__liste__titre">Coefficients utilisés</div>
                <div class="coeff__liste__line">
                  <input type="checkbox" id="cr" name="coeffsSphem" v-model="coeffs[0].active" @change="checkIsChanged(coeffs[0]._id, coeffs[0].active)">
                  <label class="coeff__liste__item" for="cr"><span class="coeff__liste__item__sphem">[Sphem] </span>Coût de Revient</label>
                </div>
                <div class="coeff__liste__line">
                  <input type="checkbox" id="pv" name="coeffsSphem" v-model="coeffs[1].active" @change="checkIsChanged(coeffs[1]._id, coeffs[1].active)">
                  <label class="coeff__liste__item" for="pv"><span class="coeff__liste__item__sphem">[Sphem] </span>Prix de vente</label>
                </div>
                  <div class="coeff__liste__line" v-for="item in coeffsPerso" :key="item._id">
                  <input type="checkbox" :id="item._id" v-model="item.active" @change="checkIsChanged(item._id, item.active)">
                  <label class="coeff__liste__item" :for="item._id"> {{item.name}} </label>
                  <span class="material-icons coeff__liste__icon" @click="deleteCoeff(item._id)">delete_outline</span>
                </div>
              </div>
              <Ajouter label="Ajouter un coefficient" labelSize=12 icon="add_circle" @submit="addCoeff($event)" :formIndex="'coeff'" class="content__list__ajouter"  />
            </div>
          </div>
          <div class="coeff__selecteur">
            <div class="coeff__selecteur__cell">
              <span class="material-icons" @click="changeYear(-1)">arrow_left</span>
              Année {{displayedYear}}
              <span class="material-icons" @click="changeYear(1)">arrow_right</span>
            </div>
          </div>
            
          <div class="coeff__calcul">
            <div class="coeff__calcul__grid1">
              <div>
                <!-- Un vide pour la première cellule de la grille -->
              </div>
              <div class="coeff__calcul__titre">Réel {{displayedYear - 1}}</div>
              <div class="coeff__calcul__titre">Estimé {{displayedYear}}</div>
              <div class="coeff__calcul__titre">Réel {{displayedYear}}</div>
              <div>
                <!-- Pas de sous titre -->
              </div>
              <div>
                <div class="coeff__calcul__sous-titre">Calculé par l'application en début d'année</div>
              </div>
                <div class="coeff__calcul__sous-titre">Valeurs prises en compte dans les calculs de l'application</div>
              <div>
                <div class="coeff__calcul__sous-titre">Calculé par l'application en fin d'année</div>
              </div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('nbJours')">help</span>Nb jours / mois :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="nbJours" :value="agence.estimationsAnnuelles.nbJours.val" @change="majEstimations($event.target, displayedYear)">
              <!-- Version non modifiable : -->
              <!-- <div class="coeff__calcul__value">{{agence.estimationsAnnuelles.nbJours.val}}</div> -->
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('nbCollaborateurs')">help</span>Nb de collaborateurs :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="nbCollaborateurs" :value="agence.estimationsAnnuelles.nbCollaborateurs.val" @change="majEstimations($event.target, displayedYear)">
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('totalCharges')">help</span>Total des charges :</div>
              <input class="coeff__calcul__value" id="totalCharges" :value="updateMontant(agence.estimationsAnnuelles.totalCharges.val).str" @change="majEstimations($event.target, displayedYear)">
              <div class="coeff__calcul__value">{{totalCharges}} €</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('salairesBruts')">help</span>> salaires bruts :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="salairesBruts" :value="updateMontant(agence.estimationsAnnuelles.salairesBruts.val).str" @change="majEstimations($event.target, displayedYear)">
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('chargesDirectes')">help</span>> charges directes :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="chargesDirectes" :value="updateMontant(agence.estimationsAnnuelles.chargesDirectes.val).str" @change="majEstimations($event.target, displayedYear)">
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('chargesIndirectes')">help</span>> charges indirectes :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="chargesIndirectes" :value="updateMontant(agence.estimationsAnnuelles.chargesIndirectes.val).str" @change="majEstimations($event.target, displayedYear)">
              <!-- ratio facturable N-1 : pour le calculer, attention à ce qu'on fait : un pourcentage du temps passé ? Ou des salaires versés ? Dans le second cas la répartition des mieux payés a plus d'impact. Plus dur à calculer, mais plus juste aussi.  -->
              <!-- Proposer les 2 ? -->
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('pourcentage')">help</span>Salaire facturable (%) :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="salaireFacturable" :value="agence.estimationsAnnuelles.salaireFacturable.val" @change="majEstimations($event.target, displayedYear)">
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('salaireMoyen')">help</span>Salaire jour moyen :</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__value">{{salaireJourMoy}} €</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('cr')">help</span>Coeff Coût de Revient :</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__value">{{cr}}</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('crJour')">help</span>CR jour moyen :</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__value">{{crJour}} €</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('marge')">help</span>Marge annuelle :</div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" id="marge" :value="updateMontant(agence.estimationsAnnuelles.marge.val).str" @change="majEstimations($event.target, displayedYear)">
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('pv')">help</span>Coeff Prix de Vente :</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__value">{{pv}}</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('pvJour')">help</span>PV jour moyen :</div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__value">{{pvJour}} €</div>
              <div class="coeff__calcul__value">-</div>
            </div>
            
            <!-- CoeffsPerso -->
            <div class="coeff__calcul__grid2" v-for="coeff in coeffsPerso" :key="coeff._id">
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('coeffPerso')">help</span> {{coeff.name}} : </div>
              <div class="coeff__calcul__value">-</div>
              <input class="coeff__calcul__value" :id="coeff._id" @change="majCoeff(coeff._id, $event.target)" :value="coeff.val">
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__label"><span class="material-icons coeff__calcul__label__icon" @click="showModale('coeffPersoJour')">help</span> > Prix jour : </div>
              <div class="coeff__calcul__value">-</div>
              <div class="coeff__calcul__value">{{Math.round(coeff.val * salaireJourMoy)}} €</div>
              <div class="coeff__calcul__value">-</div>
            </div>
          </div>

          <div id="Modales">
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'nbJours'" title="Nombre de jours moyen pas mois">
              <template v-slot:body>
                <p>En moyenne, combien y a-t-il de jours ouvrés par mois cette année ?</p>
                <p>La valeur par défaut est calculée par l'application en tenant compte des jours fériés. Pour revenir à la valeur par défaut, supprimer la valeur entrée manuellement.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'nbCollaborateurs'" title="Nombre de collaborateurs">
              <template v-slot:body>
                <p>En moyenne, combien y a-t-il de collaborateurs à temps plein cette année ?</p>
                <p>Pour les salariés qui arriveront ou partiront en cours d'année, utiliser des nombres décimaux. Pour les associés salariés ou non salariés, ne compter que ceux qui saisissent leurs temps.</p>
                <p>Cette valeur n'est pas utilisée pour calculer les coefficients. Elle est utilisée pour le calcul du salaire moyen par jour, ainsi que pour les prix jour de chaque coefficient.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'totalCharges'" title="Total des charges">
              <template v-slot:body>
                <p>Le total des charges de votre entreprise sur l'exercice comptable, tout compris.</p>
                <p>Après votre bilan comptable de l'année N-1, vous pouvez l'inscrire dans la première colonne. Cette vision de ce qui s'est réellement passé sur l'année N-1 vous permettra de mieux établir vos estimations pour l'année N.</p>
                <p>Ce total est la somme des salaires bruts, des charges directes et des charges indirectes.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'salairesBruts'" title="Salaires bruts">
              <template v-slot:body>
                <p>La somme de tous les salaires bruts à couvrir sur l'année.</p>
                <p>Pour les associés, ne compter que le salaire des associés qui saisissent leurs temps. S'ils sont associés-salariés, compter le salaire sans les dividendes (l'entreprise doit couvrir le salaire, les dividendes viennent en plus). S'ils sont travailleurs non salariés, il n'y a pas réellement de salaire à couvrir. Compter alors le salaire brut que vous estimez indispendable pour poursuivre l'activité (et faire de même dans le profil de ce collaborateur dans la rubrique "équipe").</p>
                <p>Le cas échéant, le salaire des associés qui ne saisissent pas leurs temps est intégré dans les charges indirectes.</p>
                <p>Pour l'année N-1, ce montant est calculé par l'application en fonction des salaires déclarés pour chaque collaborateur dans la rubrique "équipe".</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'chargesDirectes'" title="Charges directes">
              <template v-slot:body>
                <p>Le charges directement inputables à un projet en particulier (ex: déplacements, impressions, sous-traitance, etc.).</p>
                <p>Pour l'année N-1, ce montant est calculé par l'application en fonction des montants déclarés dans les onglets "Prestations extérieures" et "Notes de frais" pour chaque projet.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'chargesIndirectes'" title="Charges indirectes">
              <template v-slot:body>
                <p>Le autres charges de l'agence (salaire des associés qui ne saisissent pas leurs temps, loyers, assurances, matériel, etc.).</p>
                <p>Pour l'année N-1, ce montant est calculé par l'application à partir du montant total des charges que vous avez saisi. <br>> Charges indirectes = Total - Salaire bruts - Charges directes</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'pourcentage'" title="Ratio facturable / non facturable">
              <template v-slot:body>
                <p>Le pourcentage de temps passé par les collaborateurs sur des projets facturables par rapport au temps total passé.</p>
                <p>Le "temps total" ne tient pas compte des congés.</p>
                <p>Pour l'année N-1, ce montant est calculé par l'application à partir du temps saisis par les collaborateurs dans des projets facturables ou des tâches non facturables.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'salaireMoyen'" title="Salaire brut moyen quotidien">
              <template v-slot:body>
                <p>Le salaire brut moyen pour une journée de travail dans votre entreprise.</p>
                <p>Il s'agit de la somme des salaires bruts, divisée par le nombre de jours ouvrés de l'année, divisée par le nombre de collaborateurs.</p>
                <p>Par exemple ici : {{updateMontant(agence.estimationsAnnuelles.salairesBruts.val).str}} € / {{Math.round(agence.estimationsAnnuelles.nbJours.val * 12)}} jours / {{agence.estimationsAnnuelles.nbCollaborateurs.val}} collaborateurs = {{salaireJourMoy}} €/jour.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'cr'" title="Coefficient 'Coût de revient'">
              <template v-slot:body>
                <p>Le coefficient appliqué sur les salaires pour obtenir le coût réel du temps passé.</p>
                <p>Le coût d'une journée de temps passé sur un projet par un collaborateur, c'est une journée de son salaire, ainsi qu'une journée de charges indirectes (loyer, assurances, etc), et qu'une partie des temps non facturables (secrétariat, prospection, etc).</p>
                <p>Par exemple ici, le salaire moyen d'une journée de travail est de {{salaireJourMoy}} €. En multipliant ce montant par {{cr}} on obtient le coût réel d'une journée de travail, compris charges indirectes et salaires non facturables. Soit {{crJour}} €.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'crJour'" title="Coût de revient par jour">
              <template v-slot:body>
                <p>Le coût réel d'une journée de travail sur un projet facturable.</p>
                <p>Le coût d'une journée de temps passé sur un projet facturable par un collaborateur, c'est une journée de son salaire, ainsi qu'une journée de charges indirectes (loyer, assurances, etc), et qu'une partie des temps non facturables (secrétariat, prospection, etc).</p>
                <p>Par exemple ici, le salaire moyen d'une journée de travail est de {{salaireJourMoy}} €. En multipliant ce montant par {{cr}} on obtient le coût réel d'une journée de travail, compris charges indirectes et salaires non facturables. Soit {{crJour}} €.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'marge'" title="Marge annuelle">
              <template v-slot:body>
                <p>La marge réalisée sur l'année.</p>
                <p>Dans vos estimations, vous pouvez ajouter la marge que vous souhaitez réaliser cette année (pour un complément de salaire, pour des investissement futurs, etc.)</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'pv'" title="Coefficient 'Prix de vente'">
              <template v-slot:body>
                <p>Le coefficient appliqué sur les salaires pour obtenir le prix de vente du temps passé.</p>
                <p>Le prix de vente d'une journée de travail, c'est ce qu'elle coûte, additionné de la marge que l'on souhaite réaliser.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'pvJour'" title="Prix de vente par jour">
              <template v-slot:body>
                <p>Le coefficient appliqué sur les salaires pour obtenir le prix de vente du temps passé.</p>
                <p>Le prix de vente d'une journée de travail, c'est ce qu'elle coûte, additionné de la marge que l'on souhaite réaliser.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'coeffPerso'" title="Coefficient personnalisé">
              <template v-slot:body>
                <p>Vous pouvez librement définir de nouveaux coefficients avec leurs propres valeurs annuelles.</p>
              </template>
            </Modale>
            <Modale @close="closeModales" v-if="modale.val == true && modale.ref == 'coeffPersoJour'" title="Prix de vente par jour">
              <template v-slot:body>
                <p>Le prix d'une journée de travail avec ce coefficient.</p>
              </template>
            </Modale>
          </div>
          
        </template>
      </Section>
    </div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.inline-block{
  display: inline-block;
  @include myBlock;
}

.content{
  display: flex;
  justify-content: space-between;
  margin: 0 0 50px 0;

  &__text{
    @include myFont;
    font-size: 14px;
    width: 400px;
    padding: 0 20px 0 0;
    color: $black-bolder;
  }

   &__list{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 0 25px 0;
    flex: 1;

    &__item{
      width: 100%;
      display: flex;
      justify-content: space-between;

      &__label{
        @include myFont;
        font-size: 14px;
        color: $black-bolder;
      }
    }

    &__valFlagger{
      margin: 20px 0 0 0;
    }

    &__ajouter{
      margin: 15px 0 0 0;
      width: 100%;
    }
   }
}

.coeff{
  &__liste{
    @include myBlock;
    padding: 8px;
    width: 100%;
    box-sizing: border-box;

    &__titre{
      @include myFont;
      font-size: 13px;
      font-weight: 600;
      color: $main;
      margin: 0 0 15px 0;
    }

    &__line{
      display: flex;
      align-items: center;
      height: 25px;
    }

    &__item{
      @include myFont;
      font-size: 13px;
      color: $black-bolder;
      margin: 0 0 0 5px;

      &__sphem{
        color: $black;
      }
    }

    &__icon{
      color: $black-bolder;
      flex: 1;
      text-align: right;
    }
  }

  &__selecteur{
    width: 100%;
    display: grid;
    grid-template-columns: 200px repeat(3, 1fr); //idem calcul
    column-gap: 20px; //idem calcul
    box-sizing: border-box;
    padding: 0 10px; //côtés idem calcul
    margin: 0 0 10px 0;
    

    &__cell{
      grid-column: 3;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      @include myFont;
      color: $black-bolder;
    }
  }

  &__calcul{
    @include myBlock;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    &__grid1{
      display: grid;
      grid-template-columns: 200px 1fr 1fr 1fr;
      grid-template-rows: repeat(2, auto) 40px 25px 40px repeat(3, 25px) 40px 40px repeat(2, 25px) 40px repeat(2, 25px);
      column-gap: 20px;
      margin: 0 0 15px 0;
    }

    &__grid2{
      display: grid;
      grid-template-columns: 200px 1fr 1fr 1fr;
      grid-auto-rows: 25px;
      column-gap: 20px;
    }

    &__titre{
      @include myFont;
      color: $main;
      font-weight: 600;
      justify-self: center;
    }

    &__sous-titre{
      @include myFont;
      color: $black-bold;
      font-size: 11px;
      justify-self: center;
      text-align: center;
    }

    &__label{
      @include myFont;
      font-size: 13px;
      color: $black-bolder;
      align-self: end;
      display: flex;
      align-items: center;

      &__icon{
        color: $black-light;
        font-size: 20px;
        margin: 0 5px 0 0;
      }
    }

    &__value{
      justify-self: center;
      align-self: end;
      @include myFont;
      font-size: 13px;
      color: $black-bolder;

      &__error{
        background-color: $alert-lighter;
        color: $alert-bold !important;
      }
    }

    & input{
      border-width : 0 0 0px 0;
      border-color: $main;
      background-color: $main-lighter;
      border-radius: 3px;
      @include myFont;
      color: $black-bolder;
      font-size: 13px;
      text-align: center;
      width: 100%;
    }
  }
}

</style>
